/* LIBRAIRIES */
import React from 'react';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* ICONS */
import { HiPencil } from 'react-icons/hi';

/* CSS */
import './ModifyBtn.css';

const ModifyBtn = ({id, user}) => {

    const { setOpenModalModifyUser, setUserId, setUserModifyRole } = useUserContext();

    function handleClick() {
        setOpenModalModifyUser(true);
        setUserId(id);
        setUserModifyRole(user.role);
    }

    return (
        <button className='modify-button' onClick={handleClick}>
            <HiPencil className='btnModify' />
        </button>
    )
}

export default ModifyBtn